import { CHECK_AB_FLAG } from "../actions/ab-flags";

const initialState = {
  pdpInseamV2: { isEnabled: false },
  pdpGoesWellWith: { isEnabled: false },
  pdpAlsoAvailableIn: { isEnabled: false },
  pdpDesktopGoeswellwith: { isEnabled: false },
};

const abFlagsReducer = (state = initialState, { type, payload }) => {
  if (type === CHECK_AB_FLAG) {
    if (!initialState[payload.name]) {
      console.log(`Not a valid feature flag: '${payload.name}'`);
    }

    return {
      ...state,
      [payload.name]: { isEnabled: payload.isEnabled },
    };
  }

  return state;
};

export default abFlagsReducer;
